import { Container, Flex, Table, Title } from '@mantine/core';
import { ICurrency } from '../../../../libraries/currencies';
import { EquipPeriod } from '../../../../libraries/dashboardV2';
import { formatCurrAmount } from '../../../utils/script';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';
import { formatDateTimeLabel } from '../../../utils/date';

interface DashboardPeriodFieldProps {
  period: EquipPeriod;
  totalEquipment?: number;
  currencyMatch?: ICurrency;
  isDeposit: boolean;
}

const DashboardPeriodField = ({ period, totalEquipment, currencyMatch, isDeposit }: DashboardPeriodFieldProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const region = useSelector<AppState, string>(state => state.login.user?.region || 'UTC');

  const totals = period.totals.length ? period.totals[0] : { paid: 0, paidAP: 0 };
  const cashPayments = totals.paid - totals.paidAP;
  const cardPayments = totals.paidAP;

  return (
    <Container className="dashboard-table-container">
      <Flex direction="column" align="flex-start" justify="center">
        <Title order={2} className="dashboard-table-title">
          {lang.DASHBOARD_CURRENT_PERIOD}
        </Title>
      </Flex>

      <Table withRowBorders className="dashboard-table">
        <Table.Tbody>
          {/* always visible */}
          <Table.Tr>
            <Table.Td className="dashboard-currency-table-denom">{lang.DASHBOARD_PERIOD_NUMBER}</Table.Td>
            <Table.Td className="dashboard-currency-table-value">{period.period}</Table.Td>
            <Table.Td />
          </Table.Tr>

          <Table.Tr>
            <Table.Td className="dashboard-currency-table-denom">{lang.DASHBOARD_PERIOD_OPEN_DATE}</Table.Td>
            <Table.Td className="dashboard-currency-table-value">
              {formatDateTimeLabel(period.dateTimeOpen, region)}
            </Table.Td>
            <Table.Td />
          </Table.Tr>

          {/* 🔽 hidden when Deposit */}
          {currencyMatch && !isDeposit && (
            <>
              <Table.Tr>
                <Table.Td className="dashboard-currency-table-denom">{lang.DASHOBOARD_PERIOD_TOTAL_EQUIPMENT}</Table.Td>
                <Table.Td className="dashboard-currency-table-value">
                  {formatCurrAmount(totalEquipment || 0, currencyMatch)}
                </Table.Td>
                <Table.Td />
              </Table.Tr>

              <Table.Tr>
                <Table.Td className="dashboard-currency-table-denom">{lang.DASHBOARD_PERIOD_MONEY_PAY}</Table.Td>
                <Table.Td className="dashboard-currency-table-value">
                  {formatCurrAmount(cashPayments, currencyMatch)}
                </Table.Td>
                <Table.Td />
              </Table.Tr>

              <Table.Tr>
                <Table.Td className="dashboard-currency-table-denom">{lang.DASHBOARD_PERIOD_CARD_PAY}</Table.Td>
                <Table.Td className="dashboard-currency-table-value">
                  {formatCurrAmount(cardPayments, currencyMatch)}
                </Table.Td>
                <Table.Td />
              </Table.Tr>
            </>
          )}
        </Table.Tbody>
      </Table>
    </Container>
  );
};

export default DashboardPeriodField;
